import xhr from "axios/index";
import Emitter from "../eventBus";
import str2ab from "string-to-arraybuffer";
import { isTest,elementSDKAPI } from "../config";
// import {SHA256, Kec} from "@tronscan/client/src/utils/crypto.js";
// import {byteArray2hexStr} from "@tronscan/client/src/utils/bytes.js";
window.serviceFee = 0;

// const currencyList = ["TRX", "USDT", "USDD", "NFT"];
xhr.get(elementSDKAPI + "/v1/orders/confData")
    .then((res) => {
        window.serviceFee = res.data.data.relayerFee / 10000;
        window.minBid = res.data.data.engReserveMinEth;
        window.minOffer = res.data.data.offerMinEth;
        console.log("window.serviceFee",window.serviceFee)
    })
    .catch((e) => {
        console.log(e);
    });

// currencyList.map((item) => {
//     xhr.get(`https://apilist.tronscanapi.com/api/token/price?token=${item.toLocaleLowerCase()}`)
//         .then((res) => {
//             window[item] = Number(res.data["price_in_usd"]).toFixed(10);
//             localStorage.setItem(`${item}/USD`, window[item]);
//             if (item === "TRX") {
//                 window.WTRX = window.TRX;
//             }
//         })
//         .catch((e) => {
//             console.log(e);
//         });
// });

let baseApi;
if (window.location.hostname === 'nft-dev.btfs.io' || window.location.hostname === 'localhost') {
    baseApi = `https://nft-backend-dev.btfs.io`;
} else if (window.location.hostname === 'nft-staging.btfs.io') {
    baseApi = `https://nft-backend-staging.btfs.io`;
} else {
    baseApi = `https://nft-backend.btfs.io`;
}

export const sign = (content) => {
    return new Promise(async (resolve, reject) => {
        let tronWeb = window.tronWeb;
        if (tronWeb && tronWeb.defaultAddress.base58) {
            tronWeb.trx.sign(content).then((signature) => {
                resolve(signature);
            }).catch((e) => {
                resolve(false);
            })
        }
    })
}

export async function fileArrayBuffer(file) {
    return new Promise(resolve => {
        const fr = new FileReader();
        fr.onload = () => {
            resolve(fr.result);
        }
        fr.readAsArrayBuffer(file);
    })
}

export const upload = (file, address, thumbnail, config, source) => {
    return new Promise(async (resolve, reject) => {

        let arrayBuffer = await fileArrayBuffer(file);
        let uArray = new Uint8Array(arrayBuffer);
        let content = Array.from(uArray)
        if (!thumbnail) thumbnail = '';
        let others = Array.from(new Uint8Array(str2ab(address + thumbnail + file.name + file.type + file.size)));
        let data = {
            content: content,
            address: address,
            thumbnail: thumbnail,
            name: file.name,
            type: file.type,
            size: file.size
        };
        /*
                let sum = content.concat(others);
                let hashBytes = SHA256(new Uint8Array(sum));
                let hex = byteArray2hexStr(hashBytes);
                let signature = await sign(hex);
        */
        let requestBody = {...data, source};

        //  console.log('------------below post data with signature--------');
        //  console.log('hex before sign', hex);
        //  console.log(requestBody);
        /*
                if (!signature) {
                    reject(false);
                    return;
                }
        */
        xhr.post(baseApi + '/api/upload', requestBody, config).then((res) => {
            if (res.status === 200) {
                if (res.data.data['file_hash']) {
                    resolve(res.data.data['file_hash']);
                } else {
                    resolve(false)
                }
            } else {
                reject(false);
            }
        }).catch((error) => {
            reject(false);
        });

    })
}

export const mint = (currentAccount, fileHash, metadataHash, contract, blockchain, category, isOriginal, isSensible) => {
    return new Promise(async (resolve, reject) => {
        try {
            let tokenID = await getTokenID(currentAccount, fileHash, blockchain+'_'+contract, category, isOriginal, isSensible);

            let mintContract = await window.tronWeb.contract().at(contract.split('_')[1]);

            let checkID = await mintContract.ownerOf(tokenID).call((data)=>{
                console.log(data)
            });


            if(checkID) {
                resolve(null);
                return;
            }
            let result;
            if(isTest){
                result = await mintContract.mintAPEN(currentAccount, tokenID, 'https://gateway.btfs.io/btfs/'+metadataHash, fileHash).send();
            }else{
                result = await mintContract.mintBTFSNft(currentAccount, tokenID, 'https://gateway.btfs.io/btfs/'+metadataHash, fileHash).send();
            }

            if (result) {
               // let update = await updateMintStatus(tokenID);
                resolve(result);
            } else {
                resolve(null);
            }
        } catch (e) {
            console.log(e);
            resolve(null);
        }

    })
}

export const getMetadata = (contract, tokenID) => {
    return new Promise(async (resolve, reject) => {
        try {

            let mintContract = await window.tronWeb.contract().at(contract);


            let result = await mintContract.tokenURI(tokenID).call();

            if (result) {
                resolve(result);
            } else {
                resolve(null);
            }
        } catch (e) {
            console.log(e);
            resolve(null);
        }

    })
}

export const view = (hash) => {
    return new Promise(async (resolve, reject) => {
        xhr.get('https://gateway.btfs.io/btfs/' + hash, {
            responseType: 'blob',
        }).then((res) => {
            if (res.status === 200) {
                let blob = res.data;
                resolve({content: blob});
            } else {
                resolve(false);
            }
        }).catch(() => {
            resolve(false);
        })
    })
}


export const download = (hash, name, type, config) => {
    return new Promise(async (resolve, reject) => {
        xhr.get('https://gateway.btfs.io/btfs/' + hash, {
            responseType: 'blob',
            onDownloadProgress: config && config.onDownloadProgress
        }).then(
            (res) => {
              //  console.log(res.data);
                if (res.status === 200) {
                    let blob = res.data;
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display:none";
                    a.href = url;
                    a.download = name;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    resolve(true);
                } else {
                    resolve(false);
                }
            }
        ).catch((error) => {
            reject(false);
        });
    })
}


export const getFiles = (address, start, size) => {
    return new Promise(async (resolve, reject) => {
        xhr.get(baseApi + '/api/files', {
            params: {
                address: address,
                start: start,
                limit: size,
            }
        }).then((res) => {
            if (res.status === 200) {
                resolve(res.data.data ? res.data.data : {files: [], total: 0});
            } else {
                reject({files: [], total: 0});
            }
        }).catch((error) => {
            reject({files: [], total: 0});
        });
    })
}

export const subscribe = (address, email) => {
    return new Promise(async (resolve, reject) => {
        let data = {
            address: address,
            email: email,
        };
        let signature = await sign(data);

        Emitter.emit('showMessageAlert', {status: 'success', message: 'ccccccc'});
        if (!signature) {
            return;
        }
        let requestBody = {...data, signature};
        xhr.post(baseApi, requestBody).then(() => {
            Emitter.emit('showMessageAlert', {status: 'success', message: 'ccccccc'});
        }).catch((error) => {
            reject(error);
        });
    })
}

export const getStatus = (address) => {
    return new Promise(async (resolve, reject) => {
        xhr.get(baseApi + '/api/status', {
            params: {
                address: address,
            }
        }).then((res) => {
                if (res.status === 200) {
                    resolve(res.data.data ? res.data.data : {file_count: 0});
                } else {
                    reject({file_count: 0});
                }
            }
        ).catch((error) => {
            reject({file_count: 0});
        });
    })
}

export const getTokenID = (address, hash, contractType, category, isOriginal, isSensible, externalLink) => {
    return new Promise(async (resolve, reject) => {
        let data = {
            address: address,
            file_hash: hash,
            contract: contractType,
            status: 'init',
            category: category,
            is_original: isOriginal,
            is_sensible: isSensible,
            external_link: externalLink
        };
        xhr.post(baseApi + '/api/nft_tokens', data).then((res) => {
                if (res.status === 200) {
                    resolve(res.data.data['token_id'] ? res.data.data['token_id'] : 0);
                } else {
                    reject(0);
                }
            }
        ).catch((error) => {
            reject(0);
        });
    })
}

export const updateMintStatus = (token_id) => {
    return new Promise(async (resolve, reject) => {
        let data = {
            status: 'complete'
        }
        xhr.post(baseApi + '/api/nft_tokens/' + token_id, data).then((res) => {
                if (res.status === 200) {
                    resolve(res.data.data ? res.data.data : {});
                } else {
                    reject({});
                }
            }
        ).catch((error) => {
            reject({});
        });
    })
}